import {useHistory} from "react-router-dom";
import styled from 'styled-components';

import React from "react";
import {Bell, Compass, Home, TrendingUp, User} from "lucide-react";
import {useLoggedIn, useStoreProfile} from '../store';
import {themecolors} from "../utils/themecolors";
import {useActiveTab} from "../utils/url";
import {useSheetModal} from "./test/ModalContext";
import Sheet from "./bottom-sheet/sheet";
import SignupPromptSheet from "./bottom-sheet/signup_prompt";

const Tab = styled.div``;
const Unread = styled.div``;
const UnreadContainer = styled.div``;

const BottomBar = styled(({className}) => {

    const loggedIn = useLoggedIn();
    const settings = useStoreProfile();
    const inbox_type = settings.unread === 0 ? 'all' : 'unread';
    const history = useHistory();

    const { openModal } = useSheetModal();

    const handleGuest = (message) => {

        const modalContent = ({ handleCloseModal }) => (
            <Sheet onClose={() => handleCloseModal() } padding={"header"}><SignupPromptSheet message={message} onClose={() => handleCloseModal() } /></Sheet>
        );

        openModal(modalContent);

    };
    const handleUser = (url) => {
        history.push(url);
    };

    const path = window.location.pathname;
    const activeTab = useActiveTab(path);

    const tabs = [
        {
            render: () =>
                <div className={`${activeTab === "home" ? 'active' : ''}`}>
                    <Home size={24}/>
                </div>
            ,
            handler: () => handleUser('/'),
        },
        {
            render: () =>
                <div className={`${activeTab === "trending" ? 'active' : ''}`}>
                    <TrendingUp size={24}/>
                </div>
            ,
            handler: () => handleUser('/c/trending'),
        },
        {
            render: () =>
                <div className={`${activeTab === "communities" ? 'active' : ''}`}>
                    <Compass size={24}/>
                </div>
            ,
            handler: () => handleUser('/communities'),
        },
        {
            render: () => (
                loggedIn ? (
                    <UnreadContainer>
                        <div className={`${activeTab === "messages" ? 'active' : ''}`}>
                            <Bell size={24}/>
                        </div>
                        {settings.unread > 0 && (
                            <Unread>{settings.unread > 99 ? '99' : settings.unread}</Unread>
                        )}
                    </UnreadContainer>
                ) :
                    <div className={`${activeTab === "messages" ? 'active' : ''}`}>
                        <Bell size={24}/>
                    </div>
            ),
            handler: () => {
                if (loggedIn) {
                    handleUser(`/messages?type=${inbox_type}`);
                } else {
                    handleGuest('When you create an account, the notifications tab is where you’ll see responses to your posts and comments.');
                }
            },
        },
        {
            render: () =>
                <div className={`${activeTab === "account" ? 'active' : ''}`}>
                    <User size={24}/>
                </div>
            ,
            handler: () => {
                if (loggedIn) {
                    handleUser('/u/me?type=overview');
                } else {
                    handleGuest("When you create an account, your profile is where you'll be able to see your posts and comments.");
                }
            },
        },
    ];

    return (
        <footer className={className}>
            {tabs.map(({ render, handler }, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <Tab key={index} onClick={handler}>{render()}</Tab>
            ))}
        </footer>
    )
})`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-top: ${({theme}) => theme.color.name === 'dark' ? `1px solid ${themecolors.dark_background_5}` : '1px solid #d0cfcf'};
  background: ${({theme}) => theme.color.name === 'dark' ? '#121212eb': '#ffffffc7'};
  backdrop-filter: blur(8px);
  height: ${({theme}) => theme.footer.height};
  display: flex;
  justify-content: center;
  align-items: stretch;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_medium_impact_text};
  width: 100%;
  font-size: 17px;
  & > * {
    flex-grow: 1;
    flex-basis: 0;
    text-align: center;
    will-change: background-color;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${Tab} {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  ${Tab} > ${UnreadContainer} {
    position: relative;
  }
  ${Tab} span,
  ${Tab} ${UnreadContainer} {
    display: flex;
    align-items: center;
  }
  ${Unread} {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: ${({theme}) => themecolors.red};
    color: ${({theme}) => theme.white_0};
    font-weight: 600;
    font-size: 11px;
    padding: 4px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 19px;
  }
  a {
    height: 24px;
  }
  
  .active, 
  .active span {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
`;

export default BottomBar;
